module.exports = __webpack_public_path__ + "static/img/5.6aa479e1.png";